import React, {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import './CartCounter.scss';
// import { throttle } from 'lodash';
// import { Key } from '@mui/icons-material';

// const handleCartAdd = (key: any, item: any) => {
//     console.log('key', item);
// }

function CartCounter({ onValueUpdate, initialValue=1 }: any) {
    useEffect(() => {
        updateVal(initialValue);
    }, [initialValue]);
    const [value, updateVal] = useState(initialValue);
    // const setServicesValue = value => Services.setValue(value);

    // const onValueUpdateThrottled = useRef(throttle(onValueUpdate, 1000));
    const handleUpdate = (event: any, increment: number) => {
        event.stopPropagation();
        let temp = value + increment;
        temp = temp < 0 ? 0 : temp;
        temp = temp > 99 ? 99 : temp;
        updateVal(temp);
        // onValueUpdateThrottled.current(temp);
        onValueUpdate(temp);
    };

    return (
        <Paper
            sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '2px' }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        >
            <IconButton disableRipple onClick={(event) => handleUpdate(event, -1)} sx={{ p: '5px' }} aria-label="menu">
                <RemoveIcon />
            </IconButton>
            <input readOnly value={value} className='cart-input' type="number" placeholder='0' />
            <IconButton disableRipple onClick={(event) => handleUpdate(event, value > 5 ? 2 : 1)} type="button" sx={{ p: '5px' }} aria-label="search">
                <AddIcon />
            </IconButton>
        </Paper>
    );
}

export default CartCounter;
